(ns dashboard.components.popup-menu
  (:require ["react" :as react]))

(defn popup-menu [{:keys [trigger-class
                          trigger-content
                          trigger-component
                          suspend-click-to-close
                          position
                          modal-instance
                          content
                          menu-class
                          on-click
                          on-close
                          disabled]}]
  (let [position (or position :bottom)
        [visible set-visible] (react/useState false)
        [ref set-ref] (react/useState nil)
        [menu-ref set-menu-ref] (react/useState nil)
        [trigger-ref set-trigger-ref] (react/useState nil)

        on-set-visible (fn [value-or-fn]
                         (let [new-value (or (and (boolean? value-or-fn)
                                                  value-or-fn)
                                             (and (fn? value-or-fn)
                                                  (value-or-fn visible)))]
                          (if new-value
                           (when (= position :right)
                             (aset (.-style menu-ref) "top" "-8px")
                             (aset (.-style menu-ref) "right" "unset")
                             (aset (.-style menu-ref) "left" (-> trigger-ref
                                                                 .getBoundingClientRect
                                                                 .-width
                                                                 (+ 12)
                                                                 (str "px"))))
                            ;else
                            ((or on-close identity))
                            ))
                         (set-visible value-or-fn))]
    ;; Function to handle clicks outside the popup
    (react/useEffect
     (fn []
       (let [handle-click (fn [e]
                            (when (and visible
                                       (not (.contains ref (.-target e))))
                              (on-set-visible false)))]
         (.addEventListener js/document "mousedown" handle-click)
         ;; Unmount
         #(.removeEventListener js/document "mousedown" handle-click)))
     (array visible))
    ;; Optional - When provided, if the modal-instance value changes we close
    ;;            the current modal. Used for drawing this form inside of an
    ;;            ASA editor, signalling when the form is either saved or closed
    (react/useEffect
     (fn [] (on-set-visible false))
     (array modal-instance))

    [:div.dropdown
     {:class (when visible :is-active)
      :ref set-ref}
     [:div.dropdown-trigger
      [(or trigger-component :button.button)
       {:disabled disabled
        :ref set-trigger-ref
        :aria-haspopup true
        :class trigger-class
        :on-click (fn [_]
                    (on-set-visible not)
                    (when (ifn? on-click) (on-click)))}
       trigger-content]]
     (when visible
      [:div.dropdown-menu
      {:role :menu
       :ref set-menu-ref
       :class menu-class
       :on-click #(when-not suspend-click-to-close
                    (on-set-visible false))}
      [:div.dropdown-content
       (when visible content)]])]))